import React, { FC, PropsWithChildren, useCallback, useEffect } from "react";
import Close from "assets/icons/40x40/close.svg";
import { cn } from "helpers/style";
import { Z_1, Z_MODALS } from "constants/variables";
import styles from "./Modal.module.scss";

export type Props = PropsWithChildren<{
  level?: number;
  fullScreen?: boolean;
  basic?: boolean;
  onClose?: () => void;
  noClose?: boolean;
  className?: string;
  classNameBody?: string;
  classNameWrapper?: string;
  classNameClose?: string;
}>;

const Modal: FC<Props> = ({
  level = 1,
  children,
  fullScreen,
  basic,
  onClose,
  noClose = false,
  className = null,
  classNameBody = null,
  classNameWrapper = null,
  classNameClose = null,
}: Props) => {
  function onCloseHandler(e) {
    e.preventDefault();
    onClose && onClose();
  }

  const escFunction = useCallback(e => {
    if (e.key === "Escape") {
      onClose && onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={cn([styles.modalContainer, className])}
      style={{ zIndex: Z_MODALS + level || Z_1 }}
    >
      <div className={styles.modalOverlay} onClick={onCloseHandler} />
      <div
        className={cn([
          styles.modalBody,
          fullScreen && styles.fullscreen,
          classNameBody,
        ])}
      >
        {basic ? (
          <>{children}</>
        ) : (
          <div
            className={cn([
              styles.modalWrapper,
              fullScreen && styles.fullscreen,
              classNameWrapper,
            ])}
          >
            <div className={styles.modalInner}>{children}</div>
          </div>
        )}
        {!noClose && (
          <button
            className={cn([styles.modalClose, classNameClose])}
            aria-label="Закрыть"
            onClick={onCloseHandler}
          >
            <Close />
          </button>
        )}
      </div>
    </div>
  );
};

export default Modal;
